import {
  BlankSlate,
  BlankSlateActions,
  BlankSlateIcon,
  BlankSlateTitle,
  Box,
  Button,
  Card,
  CardContent,
  FileDropZone,
  FileUploadButton,
  Text,
} from "@prismicio/editor-ui"
import { useState } from "react"

import { abmLandingPagesApiClient } from "../../app/services/aiLandingPage"
import { useImportCompanies } from "./useImportCompanies"

export type CsvFile = {
  filename: string
  content: string
}

function readFile(file: File): Promise<CsvFile> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () =>
      resolve({
        filename: file.name,
        content: reader.result as string,
      })
    reader.onerror = reject
    reader.readAsText(file)
  })
}

export function UploadCompaniesTabContent() {
  const { action, disabled, taskState } = useImportCompanies({
    apiClient: abmLandingPagesApiClient,
  })

  const [csv, setCSV] = useState<CsvFile>()

  async function onFilesSelected(files: File[]) {
    const firstFile = files[0]
    if (!firstFile) return

    if (!firstFile.type.startsWith("text/")) return

    setCSV(await readFile(firstFile))
  }

  async function onImportCompanies() {
    if (!csv) return
    await action({ csv: csv.content })
  }

  return (
    <Box
      overflowY="auto"
      flexGrow={1}
      flexDirection="column"
      padding={0}
      gap={16}
    >
      <Text>
        Allow our Agent to know who are your customers and personalize logos and
        quotes based on your customers list.
      </Text>
      <Box>
        <FileDropZone
          assetType="document"
          maxFiles={1}
          onFilesSelected={onFilesSelected}
          overlay={
            <Box
              justifyContent="center"
              flexDirection="column"
              height="100%"
              padding={8}
            >
              <BlankSlate>
                <BlankSlateIcon
                  name="cloudUpload"
                  lineColor="purple10"
                  backgroundColor="purple3"
                  borderColor="purple6"
                  borderStyle="dashed"
                  size="small"
                />
                <BlankSlateTitle size="regular">
                  Drop file to instantly upload
                </BlankSlateTitle>
              </BlankSlate>
            </Box>
          }
        >
          <Card
            color="grey2"
            variant="dashed"
            paddingBlock={12}
            radius={4}
            sx={{ width: "100%" }}
          >
            <CardContent>
              <BlankSlate variant="horizontal">
                <BlankSlateIcon
                  name="cloudUpload"
                  lineColor="purple9"
                  backgroundColor="purple4"
                  size="small"
                />
                <BlankSlateTitle>
                  {csv
                    ? `${csv.filename} selected`
                    : "You haven't selected a file"}
                </BlankSlateTitle>
                <BlankSlateActions>
                  <FileUploadButton
                    onFilesSelected={onFilesSelected}
                    renderButton={(onClick) => (
                      <Box display="inline-flex" as="span">
                        <Button disabled={false} onClick={onClick} color="grey">
                          Upload file
                        </Button>
                      </Box>
                    )}
                  />
                </BlankSlateActions>
              </BlankSlate>
            </CardContent>
          </Card>
        </FileDropZone>
      </Box>
      <Box as="span">
        <Button disabled={!csv || disabled} onClick={onImportCompanies}>
          {taskState.status === "RUNNING" ? "Importing..." : "Import companies"}
        </Button>
      </Box>
    </Box>
  )
}
